import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Spinner } from "react-bootstrap"; // Import Spinner
import LogoutPage from './Logout';
import { changePassword, getAdminCredentials, getAdminById } from "../../../Api/AdminApi";
import Swal from "sweetalert2";
import { Modal, Button, Form } from "react-bootstrap";
import { CALL_IMAGE } from "../../../context/constValues";

const Header = ({ onNote }) => {
	const [headerFix, setheaderFix] = useState(false);
	const [preview, setPreview] = useState("");
	const [DATAUSER, setDATAUSER] = useState("");
	const [loading, setLoading] = useState(true); // Loading state
	const [showPasswordModal, setShowPasswordModal] = useState(false);
	const [passwordData, setPasswordData] = useState({
		currentPassword: "",
		newPassword: "",
		confirmPassword: "",
	});
	useEffect(() => {
		const handleScroll = () => {
			setheaderFix(window.scrollY > 50);
		};
		window.addEventListener("scroll", handleScroll);
		assignValue();
		return () => window.removeEventListener("scroll", handleScroll);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const assignValue = async () => {
		try {
			const resultUser = await getAdminCredentials();
			const datauser = await getAdminById(resultUser.IdUsuario);
			setDATAUSER(datauser[0]);
			const res =  await fetch(`${CALL_IMAGE}${datauser[0].foto}`);
			const imageBlob = await res.blob();
			const imageObjectURL = URL.createObjectURL(imageBlob);
			setPreview(imageObjectURL);
		} catch (error) {
			console.error("Error fetching image:", error);
		} finally {
			setLoading(false); // Stop loading regardless of success or error
		}
	};
	const handleShowPasswordModal = () => setShowPasswordModal(true);
	const handleClosePasswordModal = () => {
		setShowPasswordModal(false);
		setPasswordData({
			currentPassword: "",
			newPassword: "",
			confirmPassword: "",
		});
	};

	// Handle input changes
	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setPasswordData((prev) => ({ ...prev, [name]: value }));
	};

	// Handle password change submission
	const handlePasswordSubmit = async (e) => {
		e.preventDefault();
		const { currentPassword, newPassword, confirmPassword } = passwordData;

		// Basic validation
		if (!currentPassword || !newPassword || !confirmPassword) {
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "Por favor, completa todos los campos.",
			});
			return;
		}

		if (newPassword !== confirmPassword) {
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "La nueva contraseña y la confirmación no coinciden.",
			});
			return;
		}

		if (newPassword.length < 6) {
			Swal.fire({
				icon: "error",
				title: "Error",
				text: "La nueva contraseña debe tener al menos 6 caracteres.",
			});
			return;
		}

		try {
			Swal.fire({
				title: "Actualizando contraseña",
				allowOutsideClick: false,
				showConfirmButton: false,
			});

			// Assuming API expects user ID from userdata and passwords
			const response = await changePassword({
				currentPassword,
				newPassword,
			});
			if (response) {
				Swal.close();
				Swal.fire({
					icon: "success",
					title: "Éxito",
					text: "Contraseña actualizada correctamente.",
				});
				handleClosePasswordModal();
			} else {
				throw new Error(response.message || "Error al cambiar la contraseña");
			}
		} catch (err) {
			Swal.close();
			Swal.fire({
				icon: "error",
				title: "Error",
				text: err.message || "No se pudo actualizar la contraseña.",
			});
		}
	};
	return (
		<div className={`header ${headerFix ? "sticky" : ""}`}>
			<div className="header-content">
				<nav className="navbar navbar-expand">
					<div className="collapse navbar-collapse justify-content-between">
						<div className="header-left"></div>
						<ul className="navbar-nav header-right">
							<li className="nav-item">
								<Dropdown className="dropdown header-profile2">
									<Dropdown.Toggle variant="" as="a" className="nav-link i-false c-pointer">
										<div className="header-info2 d-flex align-items-center">
											<div className="d-flex align-items-center sidebar-info mr-2">
												<div>
													<h4 className="mb-0">{DATAUSER.nombrecompleto}</h4>
												</div>
											</div>
											{/* Spinner or Image */}
											{loading ? (
												<Spinner
													animation="border"
													role="status"
													style={{
														width: "42px",
														height: "42px",
														borderWidth: "3px",
														marginLeft: "10px"
													}}
												>
													<span className="visually-hidden">Loading...</span>
												</Spinner>
											) : (
												<img
													src={preview}
													alt=""
													style={{
														width: "42px",
														height: "42px",
														objectFit: "cover",
														borderRadius: "50%",
														marginLeft: "10px"
													}}
												/>
											)}
										</div>
									</Dropdown.Toggle>
									<Dropdown.Menu align="end" className="mt-3 dropdown-menu dropdown-menu-end">
										<Link to="#" className="dropdown-item ai-icon" onClick={handleShowPasswordModal}>
											<span className="ms-2">Cambiar Contraseña</span>
										</Link>
										<LogoutPage />
									</Dropdown.Menu>
								</Dropdown>
							</li>
						</ul>
					</div>
				</nav>
			</div>
			<Modal
				show={showPasswordModal}
				onHide={handleClosePasswordModal}
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Cambiar Contraseña</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form onSubmit={handlePasswordSubmit}>
						<Form.Group className="mb-3">
							<Form.Label>Contraseña Actual</Form.Label>
							<Form.Control
								type="password"
								name="currentPassword"
								value={passwordData.currentPassword}
								onChange={handleInputChange}
								placeholder="Ingresa tu contraseña actual"
								required
							/>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Nueva Contraseña</Form.Label>
							<Form.Control
								type="password"
								name="newPassword"
								value={passwordData.newPassword}
								onChange={handleInputChange}
								placeholder="Ingresa tu nueva contraseña"
								required
							/>
						</Form.Group>
						<Form.Group className="mb-3">
							<Form.Label>Confirmar Nueva Contraseña</Form.Label>
							<Form.Control
								type="password"
								name="confirmPassword"
								value={passwordData.confirmPassword}
								onChange={handleInputChange}
								placeholder="Confirma tu nueva contraseña"
								required
							/>
						</Form.Group>
						<div className="d-flex justify-content-end">
							<Button
								variant="danger"
								onClick={handleClosePasswordModal}
								className="me-2"
							>
								Cancelar
							</Button>
							<Button variant="primary" type="submit">
								Guardar
							</Button>
						</div>
					</Form>
				</Modal.Body>
			</Modal>
		</div>
	);
};

export default Header;